/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Included_4Inputs */

const tr_landing_pricing_included_4 = /** @type {(inputs: Landing_Pricing_Included_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taahhütsüz iptal`)
};

const en_landing_pricing_included_4 = /** @type {(inputs: Landing_Pricing_Included_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel anytime`)
};

const de_landing_pricing_included_4 = /** @type {(inputs: Landing_Pricing_Included_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit kündbar`)
};

const ru_landing_pricing_included_4 = /** @type {(inputs: Landing_Pricing_Included_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена в любой момент`)
};

/**
* | output |
* | --- |
* | "Cancel anytime" |
*
* @param {Landing_Pricing_Included_4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_included_4 = /** @type {((inputs?: Landing_Pricing_Included_4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Included_4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_included_4(inputs)
	if (locale === "de") return de_landing_pricing_included_4(inputs)
	if (locale === "ru") return ru_landing_pricing_included_4(inputs)
	return tr_landing_pricing_included_4(inputs)
});